import { fetchGalleryData, fetchImageData } from "./actions/index";
import {
  galleryReducer,
  imageReducer,
  uploadImageReducer,
  updateImageReducer,
  deleteImageReducer,
} from "./reducer";

const galleryReducers = {
  galleryGlobalStore: galleryReducer,
  imageGlobalStore: imageReducer,
  uploadImageGlobalStore: uploadImageReducer,
  updateImageGlobalStore: updateImageReducer,
  deleteImageGlobalStore: deleteImageReducer,
};

export { fetchGalleryData, fetchImageData, galleryReducers };